module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<ngeo-modal ngeo-modal-destroy-content-on-hide="true" ng-model="ctrl.showegt">\n    <mapbs-egtsingle-display\n        ng-if="ctrl.showegt"\n        mapbs-egtsingle-display-egtinfo="ctrl.egtinfo"\n        mapbs-egtsingle-display-showcaptcha="ctrl.rendercaptcha"\n        mapbs-selectegt="ctrl.selectegt(lgt)"\n    ></mapbs-egtsingle-display>\n</ngeo-modal>';

}
return __p
}